<template>
  <div class="app">
    <div class="mui-card">
      <mt-loadmore :bottom-method="loadBottom" @bottom-status-change="handleBottomChange" :bottom-all-loaded="allLoaded" :auto-fill="false" ref="loadmore">
        <ul class="mui-table-view mui-table-view-chevron">
          <li class="mui-table-view-cell mui-media" v-for="(item, key) in postList" :key="key">
            <router-link class="mui-navigate-right" :to="'/facilities/facilities_' + item.buildingdevicetype_id + '/' + ((item.status == 1) ? 2 : 20)  + '/' + item.task_id + '/' + item.building_id + '/' + item.buildingdevicetype_id + '/' + item.id">
              <img class="mui-media-object mui-pull-left" src="/static/images/avatar.png">
              <div class="mui-media-body">
                <div class="mui-media-body-left">
                  {{ item.buildingname }}
                  <div class="mui-media-body-left-bottom">
                    <div class="mui-media-body-left-bottom-left">{{ item.positiondesc }}</div>
                  </div>
                </div>
                <div class="mui-media-body-right">
                  <span class="mui-badge mui-badge-success" v-if="item.status === '1'">已审核</span>
                  <span class="mui-badge mui-badge-danger" v-if="item.status === '2'">已驳回</span>
                  <span class="mui-badge mui-badge-primary" v-if="item.status === '0'">待审核</span>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
        <div v-if="allLoaded" style="text-align:center;" class="data-none">没有更多数据了</div>
        <div slot="bottom" class="mint-loadmore-bottom">
          <span v-show="bottomStatus !== 'loading'" :class="{ 'is-rotate': bottomStatus === 'drop' }">↑</span>
          <span v-show="bottomStatus === 'loading'">
            <mt-spinner v-show="bottomStatus === 'loading'" color="#26a2ff"></mt-spinner>
          </span>
        </div>
      </mt-loadmore>
    </div>
  </div>
</template>

<script>
export default {
  name: 'contributionDetail',
  data () {
    return {
      postList: [],
      score: 0,
      allLoaded: false,
      offset: 0,
      limit: 10,
      InitialLoading: true,
      bottomStatus: '',
      title:'上报记录'
    }
  },
  created () {
    this.getMyPostList(this.offset, this.limit),
    this.$emit('getTitle', this.title)
  },
  methods: {
    getMyPostList (offset, limit) {
      let select = {
        offset: offset,
        limit: limit
      }
      this.$http.post('api/gather/getMyPostList', select, {emulateJSON: true})
        .then(function (data) {
          if (offset !== 0) {
            for (let i = 0; i < data.body.data.list.length; i++) {
              this.postList.push(data.body.data.list[i])
            }
          } else {
            this.postList = data.body.data.list
          }

          if (data.body.data.list.length < this.limit && offset !== 0) {
            this.allLoaded = true
          }
        })
    },
    loadBottom () {
      this.handleBottomChange('loading')
      this.offset += this.limit
      this.getMyPostList(this.offset, this.limit)
      setTimeout(() => {
        this.handleBottomChange('loadingEnd')
      }, 3000)
      this.$refs.loadmore.onBottomLoaded()
    },
    handleBottomChange (status) {
      this.bottomStatus = status
    }
  }
}
</script>

<style scoped lang="scss">
.app{
  margin-bottom: 60px;
}
.mui-card-footer img{
  width: 15%;
}

.mint-swipe{
  height:178.5px;
  .mint-swipe-item{
    img{
      width: 100%;
    }
  }
}

.mui-table-view{
  .mui-table-view-cell{
    .mui-navigate-right{
      .mui-media-body{
        .mui-media-body-left{
          width: 70%;
          float: left;
          .mui-media-body-left-bottom{
            .mui-media-body-left-bottom-left{
              width: 70%;
              font-size: 14px;
              color: #8f8f94;
              overflow:hidden;
              text-overflow:ellipsis;
              display: inline-block;
            }
            .mui-media-body-left-bottom-right{
              width: 20%;
              font-size: 14px;
              color: #8f8f94;
              overflow:hidden;
              text-overflow:ellipsis;
              display: inline-block;
            }
          }
        }
        .mui-media-body-right{
          width: 30%;
          font-size: 14px;
          text-align: center;
          display: inline-block;
          margin-top: 14px;
        }
      }
    }
  }
}

.mui-table-view-chevron .mui-table-view-cell {
  padding-right: 57px;
}

#add-button{
  position: fixed;
  margin: 10px;
  width: 95%;
  bottom: 50px;
  .mui-btn{
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/contributionDetail.vue